<template>
  <v-app>
    <v-main>
      <router-view :dataLoaded="dataLoaded" />
    </v-main>
  </v-app>
</template>

<script>
import routerNames from "./router/router-names";
import { useLoanEnquiryStore } from "./stores/loan-enquiry-store";

export default {
  name: "App",
  data: () => ({
    dataLoaded: false,
  }),
  setup() {    
    const { loadLoanEnquiryConfig, resetState } = useLoanEnquiryStore();
    return { loadLoanEnquiryConfig, resetState };
  },
  async created() {    
    
    var rName = this.$router.currentRoute.value.name;
    if ( rName === routerNames.Home || rName === routerNames.DocPackUpload ) {
      // Clear saved state on initial step
      this.resetState();
    }    
    
    // Load Global Configuration at open-module creation
    const resp = await this.loadLoanEnquiryConfig();
    this.dataLoaded = (resp != false);

    // Set CU Skin at startUp
    if (resp == false) console.log("Error reading Global Configuration !!");
    else {
      if (resp.LoanEnquiryConfig.Theme) {
        Object.keys(resp.LoanEnquiryConfig.Theme).forEach((i) => {
          this.$vuetify.theme.themes.light.colors[i] = resp.LoanEnquiryConfig.Theme[i];
        });
      } else console.log("Theme not found in configuration!!");
    }
  }  
};
</script>

<style lang="scss">
@import "@/shared/design/common.scss";
@import "design/styles.scss";
</style>
